<div *ngIf="filial">
  <xng-breadcrumb></xng-breadcrumb>
</div>
<div *ngIf="isLoading">
  <div *appSpinner="isLoading; message: 'Loading...'"></div>
</div>
<div *ngIf="isAllIventars" class="container pt-4 ">
  <h5 class="orange pt-4" translate>filials.filial.inventories</h5>
  <div  class="row mt-4">
    <app-search-input class="col-6" style="max-width: 300px; display: block;" [placeholder]="'global.searchByName' | translate"
      [searchControl]="searchControl"></app-search-input>
    <app-custom-select style="max-width: 300px; display: block;" [options]="companies"
      (selectionChange)="onSelectionChange($event)"></app-custom-select>
  </div>
</div>
<div *ngIf="!isLoading" class="container pt-4">
  <div class="card mb-4">
    <div *ngIf="!isAllIventars" class="card-body d-flex justify-content-between">
      <h5 class="card-title cut_text orange">{{filial?.name}}</h5>
      <span><i class='bx bx-buildings building light_blue'></i></span>
    </div>
    <ul *ngIf="!isAllIventars" class="list-group list-group-flush">
      <li class="list-group-item cut_text" translate
        [translateParams]="{value: filial?.address ? filial.address : '/'}"><span><i
            class='bx bxs-city me-2 light_blue'></i></span>filials.address</li>
      <li class="list-group-item" translate [translateParams]="{value: filial?.phone ? filial.phone : '/'}"><span><i
            class='bx bxs-phone me-2 light_blue'></i></span>filials.phone</li>
      <li *ngIf="currentUser.role.name === 'root'" class="list-group-item cut_text" ><span><i
      class='bx bx-buildings me-2 light_blue'></i></span>Company: {{company.name}}</li>
    </ul>
    <div class="card-body">
      <div *ngIf="!isAllIventars" class="d-flex justify-content-between">
        <h5 class="orange" translate>filials.filial.inventories</h5>
          <app-search-input class="search-input" [placeholder]="'filials.filial.searchByVin' | translate" [searchControl]="vinFormControl"></app-search-input>
          <app-search-input class="search-input" [placeholder]="'filials.filial.searchByReference' | translate" [searchControl]="referenceFormControl"></app-search-input>
        <div class="d-flex justify-content-end mb-3">
          <button (click)="onAddInventory()" class="custom_button" translate><i
              class='bx orange bx-plus mr-1'></i>filials.filial.newInventory</button>
        </div>
      </div>

      <ng-template [ngIf]="!isAllIventars" [ngIfElse]="withPagination">
        <div *ngIf="!inventars.length" translate>filials.filial.noInventories</div>
        <ul *ngIf="inventars.length" class="p-0">
          <li *ngFor="let inventar of inventars">
            <app-inventar-item [inventar]="inventar" [workers]="workers" [isAllIventars]="isAllIventars"
              (onEdit)="onEdit($event)" (onFinish)="onFinish($event)" (onDelete)="onDelete($event)"
              (onDownloadCsv)="onDownloadCsv($event)" (onCopyInventar)="onCopyInventar($event)"></app-inventar-item>
          </li>
        </ul>
      </ng-template>
      <ng-template #withPagination>
        <div *ngIf="!inventars.inventars.length" translate>filials.filial.noInventories</div>
        <ul *ngIf="inventars.inventars.length" class="p-0">
          <li *ngFor="let inventar of inventars.inventars">
            <app-inventar-item [inventar]="inventar" [workers]="workers" [isAllIventars]="isAllIventars"
              (onEdit)="onEdit($event)" (onFinish)="onFinish($event)" (onDelete)="onDelete($event)"
              (onDownloadCsv)="onDownloadCsv($event)"></app-inventar-item>
          </li>
        </ul>
        <ngb-pagination [collectionSize]="inventars.totalCount" [(pageSize)]="perPage" [(page)]="page" [maxSize]="5"
          [rotate]="true" (pageChange)="jumpToPage($event)"></ngb-pagination>
      </ng-template>

      
    </div>
  </div>
</div>

<app-modal (close)="toggleNewInventory = !toggleNewInventory" *ngIf="toggleNewInventory">
  <div class="modal_container"
    style="text-align: initial; font-weight: 300 !important; letter-spacing: 1px; color: #15171a;">
    <div class="modal-header">
      <h4 class="modal-title orange" style="font-size: 1rem; font-weight: inherit;" translate>filials.filial.newInventory</h4>
    </div>
    <div class="modal-body">
      <form #inventarForm="ngForm" class="form-vehicle">
        <!-- Name -->
        <div class="form-group mb-2">
          <label translate>global.name</label>
          <input type="text" #name="ngModel" autocomplete="off" required [ngModel]="inventar.name" class="form-control"
            [class.is-invalid]="name.invalid && name.touched" name="name">
        </div>

        <!-- Description -->
        <div class="form-group mb-2">
          <label translate>global.description</label>
          <input type="text" #description="ngModel" autocomplete="off" [ngModel]="inventar.description"
            class="form-control" name="description">
        </div>

        <!-- workers -->
        <div *ngIf="inventar?.isNew" class="form-group mb-2">
          <label translate>workers.workers</label>
          <select class="form-control" (change)="selectWorker($event)" name="inventar">
            <option value="" selected translate>workers.selectWorker</option>
            <option *ngFor="let worker of workers" [value]="worker.id">{{worker.name}}</option>
          </select>
          <div class="d-flex px-2" *ngFor="let selectedWorker of selectedWorkers">
            <p class="pr-1">{{selectedWorker.name}}</p>
            <span style="cursor: pointer;" (click)="removeWorker(selectedWorker)">&times;</span>
          </div>
        </div>

        <div class="form-group mb-2">
          <label translate>global.permanent</label>
          <input type="checkbox" #status="ngModel" [ngModel]="inventar.status === 'permanent'"
            class="form-checkbox" name="status">
        </div>

        <app-button *ngIf="inventar?.isNew" [text]="'global.save'" [loading]="isLoadingForm"
          (onClick)="addInventory(inventarForm)"></app-button>
        <app-button *ngIf="!inventar.isNew" [text]="'global.edit'" [loading]="isLoadingForm"
          (onClick)="editInventar(inventarForm)"></app-button>

      </form>
    </div>
  </div>
</app-modal>

<app-modal (close)="toggleDeleteInventar = !toggleDeleteInventar" *ngIf="toggleDeleteInventar">
  <div class="modal_container"
    style="text-align: initial; font-weight: 300 !important; letter-spacing: 1px; color: #15171a;">
    <div class="modal-header">
      <h4 class="modal-title" style="font-size: 1rem; font-weight: inherit;" translate
        [translateParams]="{name: inventar.name}">global.deleteInfo</h4>
    </div>
    <div class="modal-body">
      <button class="custom_button" (click)="deleteInventar()" translate>global.yes</button>
      <button class="custom_button" (click)="toggleDeleteInventar = false;" translate>global.no</button>
    </div>
  </div>
</app-modal>

<app-modal (close)="toggleFinishInfo = !toggleFinishInfo" *ngIf="toggleFinishInfo">
  <div class="modal_container"
    style="text-align: initial; font-weight: 300 !important; letter-spacing: 1px; color: #15171a;">
    <div class="modal-header">
      <h4 class="modal-title" style="font-size: 1rem; font-weight: inherit;" translate>global.finish</h4>
    </div>
    <div class="modal-body">
      <p *ngIf="!['finished', 'permanent'].includes(inventar.status)" translate>filials.filial.finishInventoryInfo</p>
      <button *ngIf="!['finished', 'permanent'].includes(inventar.status)" class="custom_button" (click)="finishInventar()" translate>global.yes</button>
      <button *ngIf="!['finished', 'permanent'].includes(inventar.status)" class="custom_button" (click)="toggleFinishInfo = false;"
        translate>global.no</button>
      <form *ngIf="inventar.status === 'finished'" #inventar="ngForm" class="form-vehicle">
        <!-- Reason -->
        <div class="form-group mb-2">
          <label translate>filials.filial.enterReasonInfo</label>
          <textarea type="text" #reason="ngModel" autocomplete="off" required [ngModel] class="form-control"
            [class.is-invalid]="reason.invalid && reason.touched" name="reason"></textarea>
        </div>
        <button class="custom_button" (click)="openInventar(inventar)" translate>global.open</button>
        <button class="custom_button" (click)="toggleFinishInfo = false;" translate>global.cancel</button>
      </form>
    </div>

  </div>
</app-modal>


<app-modal (close)="toggleImportCSV = !toggleImportCSV" *ngIf="toggleImportCSV">
  <div class="modal_container"
    style="text-align: initial; font-weight: 300 !important; letter-spacing: 1px; color: #15171a;">
    <div class="modal-header">
      <h4 class="modal-title" style="font-size: 1rem; font-weight: inherit;" translate>filials.filial.importCSV</h4>
    </div>
    <div class="modal-body">
      <label for="" translate>filials.filial.selectCSV</label>
      <input type="file" (click)="removeInputValue($event)" (change)="fileChangeEvent($event)">
    </div>
  </div>
</app-modal>